import React, { Component } from 'react';

export class joinus extends Component {
    render() {
        return (
            <div>
                <h1> Join us</h1>
            </div>
        )
    }
}

export default joinus;
